var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThongKeChung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000001651930708333951980000002031150621119827374_);}\n\t.st2{fill:url(#SVGID_00000117669467756352420870000013826986774174646429_);}\n\t.st3{fill:url(#SVGID_00000084512875092220340710000012802623030023921817_);}\n\t.st4{fill:url(#SVGID_00000179643506351079621820000011810183095344830622_);}\n\t.st5{fill:url(#SVGID_00000126305766435285755160000005383931438701417890_);}\n\t.st6{fill:url(#SVGID_00000020382227975208069890000015057329146890065045_);}\n\t.st7{fill:url(#SVGID_00000169554679862933048700000005310343899594535560_);}\n\t.st8{fill:url(#SVGID_00000059310187057390753560000007056726488293260978_);}\n\t.st9{fill:url(#SVGID_00000063593462479051916680000006426810384809358495_);}\n\t.st10{fill:url(#SVGID_00000083782586470813658660000008722710337640403878_);}\n\t.st11{fill:url(#SVGID_00000026843072703430864820000003250725034179820464_);}\n\t.st12{fill:url(#SVGID_00000021798299673355075650000014130259538051788220_);}\n\t.st13{fill:url(#SVGID_00000133523034251590210870000011390978058694690475_);}\n\t.st14{fill:url(#SVGID_00000126290147085263720930000002879794723250151851_);}\n\t.st15{fill:url(#SVGID_00000181789903568853783670000015531074419167226005_);}\n\t.st16{fill:url(#SVGID_00000049182546461032046510000008583378135545364111_);}\n\t.st17{fill:url(#SVGID_00000111159368443502008050000017262329547611800211_);}\n\t.st18{fill:url(#SVGID_00000161597904061463383010000009955746371639030162_);}\n\t.st19{fill:url(#SVGID_00000091703327682841063620000000363962235746575745_);}\n\t.st20{fill:url(#SVGID_00000061432154408637827420000014656097577991203214_);}\n\t.st21{fill:url(#SVGID_00000166675316377348314320000002837444359835531398_);}\n\t.st22{fill:url(#SVGID_00000147215422640424451370000009532770007700268930_);}\n\t.st23{fill:url(#SVGID_00000123404876700158977650000008215655654267033251_);}\n\t.st24{fill:url(#SVGID_00000079448329137932267940000003252873639227613070_);}\n\t.st25{fill:url(#SVGID_00000065043564978064038160000008123242726095826073_);}\n\t.st26{fill:url(#SVGID_00000100369544566823840290000015648130163453401769_);}\n\t.st27{fill:url(#SVGID_00000079449974286052907770000003194150132952565429_);}\n\t.st28{fill:url(#SVGID_00000130635447414776391490000015536225197116866970_);}\n\t.st29{fill:url(#SVGID_00000026866937304740863220000007252416359939851413_);}\n\t.st30{fill:url(#SVGID_00000157986397983556317340000009328223271018376320_);}\n\t.st31{fill:url(#SVGID_00000023999636686314078500000001777737734752822404_);}\n\t.st32{fill:url(#SVGID_00000023251012784531921110000009414322682240387771_);}\n\t.st33{fill:url(#SVGID_00000063596565645374839910000002072788982413764511_);}\n\t.st34{fill:url(#SVGID_00000091014289306073036410000002239574292459529407_);}\n\t.st35{fill:url(#SVGID_00000049201917886889500670000012796318708957586851_);}\n\t.st36{fill:url(#SVGID_00000145048374105230085410000000045727441816133032_);}\n\t.st37{fill:url(#SVGID_00000098918252106238568700000002662106622170334910_);}\n\t.st38{fill:url(#SVGID_00000033338195444646763460000011354187108105288354_);}\n\t.st39{fill:url(#SVGID_00000001664740155206428240000016945499846269788838_);}\n\t.st40{fill:url(#SVGID_00000091014053253295865930000014020200008651320979_);}\n\t.st41{fill:url(#SVGID_00000134935650326123334320000004362561108312752533_);}\n\t.st42{fill:url(#SVGID_00000034054910124803868070000012899891234807779228_);}\n\t.st43{fill:url(#SVGID_00000173120232566788516820000017020155190819068556_);}\n\t.st44{fill:url(#SVGID_00000136399581162158799210000003082521166814171316_);}\n\t.st45{fill:url(#SVGID_00000052813184937721722690000009235227767969076137_);}\n\t.st46{fill:url(#SVGID_00000142882317083807692700000008395709350205954744_);}\n\t.st47{fill:url(#SVGID_00000126323844343527144180000013366521391851729297_);}\n\t.st48{fill:url(#SVGID_00000153671687546745646110000012296637405250456503_);}\n\t.st49{fill:url(#SVGID_00000030466693179923555850000005271636340950645402_);}\n\t.st50{fill:url(#SVGID_00000170243229986966822340000010970326940785277328_);}\n\t.st51{fill:url(#SVGID_00000029756182080803420010000018032068234538262718_);}\n\t.st52{fill:url(#SVGID_00000068670130467084957160000008500909764547636866_);}\n\t.st53{fill:url(#SVGID_00000088852762993724393580000010478644758568366470_);}\n\t.st54{fill:url(#SVGID_00000182491017059034936180000014030735051730093207_);}\n\t.st55{fill:url(#SVGID_00000110442755378341084200000017226984263882748561_);}\n\t.st56{fill:url(#SVGID_00000129923244589706207720000008043258438807871397_);}\n\t.st57{fill:#FFFFFF;}\n\t.st58{fill:url(#SVGID_00000029009106519197224480000014066274318078178202_);}\n\t.st59{fill:url(#SVGID_00000029723838365025254130000003181199425537770410_);}\n\t.st60{fill:url(#SVGID_00000062167934743777942930000015892678589352355480_);}\n\t.st61{fill:url(#SVGID_00000018223350109686164760000005519627640289439127_);}\n\t.st62{fill:url(#SVGID_00000178195266012649242680000008787628646030618016_);}\n\t.st63{fill:url(#SVGID_00000040574584260679472020000017342448740340238721_);}\n\t.st64{fill:url(#SVGID_00000128486372824995618270000004903339776355433868_);}\n\t.st65{fill:url(#SVGID_00000128472391641961527610000002684627584310859940_);}\n\t.st66{fill:url(#SVGID_00000090290785254647380770000012707972740999938495_);}\n\t.st67{fill:url(#SVGID_00000155854674730290519750000009187387615123018922_);}\n\t.st68{fill:url(#SVGID_00000088855607190291319280000016811431790245876887_);}\n\t.st69{fill:url(#SVGID_00000060713878273972766680000003414412965568141237_);}\n\t.st70{fill:url(#SVGID_00000015355681019511379540000009273118172375041959_);}\n\t.st71{fill:url(#SVGID_00000113321007809689781320000016899355423420541850_);}\n\t.st72{fill:url(#SVGID_00000077291713210615696260000016403796663240474252_);}\n\t.st73{fill:url(#SVGID_00000003096890580561190800000004961304609280485276_);}\n\t.st74{fill:url(#SVGID_00000166651039535325049690000016635734816638065853_);}\n\t.st75{fill:url(#SVGID_00000054240584325314109130000002180122603810745013_);}\n\t.st76{fill:url(#SVGID_00000047759985374774237380000008028770163631573917_);}\n\t.st77{fill:url(#SVGID_00000145055644973324660490000008791577265256277941_);}\n\t.st78{fill:url(#SVGID_00000106128779807395232360000001300059834972539280_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9503,
    y1: 42.0929,
    x2: 32.6525,
    y2: 14.6461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.53,37.13c0.34,0,0.6,0,0.86,0c10.21,0,20.42,0,30.64,0c0.27,0,0.53-0.01,0.79,0.03 c0.73,0.12,1.23,0.75,1.22,1.48c-0.01,0.73-0.55,1.34-1.28,1.43c-0.26,0.03-0.53,0.02-0.8,0.02c-10.79,0-21.58,0-32.37,0 c-1.63,0-2.05-0.42-2.05-2.06c0-9.17,0-18.35,0-27.52c0-1.05,0.48-1.68,1.32-1.76c0.97-0.09,1.66,0.56,1.66,1.64 c0.01,2.17,0,4.35,0,6.52c0,6.45,0,12.89,0,19.34C7.53,36.51,7.53,36.77,7.53,37.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045589325274005689710000009789363498255751086_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2212,
    y1: 48.2198,
    x2: 39.8549,
    y2: 23.8131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045589325274005689710000009789363498255751086_)"
    },
    d: "M35.79,24.99c0-2.87,0-3.23,0-6.1 c0-0.26-0.01-0.53,0.04-0.79c0.12-0.72,0.76-1.21,1.51-1.19c0.71,0.02,1.3,0.53,1.4,1.23c0.03,0.24,0.03,0.48,0.03,0.72 c0,5.84,0,9.16,0,15c0,0.36-0.01,0.74-0.12,1.06c-0.22,0.62-0.94,0.98-1.59,0.87c-0.71-0.12-1.22-0.65-1.23-1.39 c-0.03-1.4-0.02-2.8-0.02-4.2C35.79,28.46,35.79,26.73,35.79,24.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011013240108301449910000005470017965117565350_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4189,
    y1: 40.5472,
    x2: 31.1211,
    y2: 13.1004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011013240108301449910000005470017965117565350_)"
    },
    d: "M14.97,27.6c0-2.15,0-4.3,0-6.45 c0-1.05,0.56-1.69,1.46-1.7c0.93-0.02,1.52,0.64,1.53,1.72c0.01,4.3,0.01,8.59,0,12.89c0,1.07-0.61,1.76-1.51,1.75 c-0.9-0.01-1.48-0.68-1.48-1.77C14.97,31.9,14.97,29.75,14.97,27.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026850099298220553810000001829021355966877316_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.4641,
    y1: 48.6673,
    x2: 39.1663,
    y2: 21.2205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026850099298220553810000001829021355966877316_)"
    },
    d: "M30.59,28.2c0-1.93-0.01-3.86,0-5.79 c0-1.08,0.6-1.75,1.51-1.73c0.89,0.02,1.46,0.66,1.46,1.71c0.01,3.91,0.01,7.82,0,11.73c0,1.04-0.59,1.69-1.47,1.71 c-0.9,0.01-1.49-0.67-1.49-1.75C30.59,32.11,30.6,30.15,30.59,28.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143587518368869829230000012054626801311188382_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.8663,
    y1: 38.9801,
    x2: 29.5684,
    y2: 11.5333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143587518368869829230000012054626801311188382_)"
    },
    d: "M9.77,29.61c0-1.45-0.01-2.9,0-4.35 c0.01-1.07,0.6-1.74,1.51-1.73c0.89,0.01,1.47,0.67,1.48,1.7c0.01,2.95,0.01,5.89,0,8.84c0,1.06-0.62,1.76-1.52,1.74 c-0.89-0.02-1.46-0.68-1.47-1.71C9.76,32.61,9.77,31.11,9.77,29.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100382086845736572900000006582414133558047163_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.0223,
    y1: 44.1841,
    x2: 34.7244,
    y2: 16.7373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100382086845736572900000006582414133558047163_)"
    },
    d: "M20.18,29.64c0-1.47-0.01-2.95,0-4.42 c0.01-1.03,0.59-1.68,1.49-1.68c0.9,0,1.49,0.64,1.5,1.68c0.01,2.97,0.01,5.94,0,8.91c0,1.02-0.62,1.68-1.5,1.69 c-0.88,0.01-1.48-0.67-1.49-1.69C20.17,32.63,20.18,31.13,20.18,29.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052074037172208811630000004460548158468048560_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8709,
    y1: 47.0592,
    x2: 37.573,
    y2: 19.6124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052074037172208811630000004460548158468048560_)"
    },
    d: "M25.4,30.16c0-1.3-0.01-2.6,0-3.9 c0.01-1.01,0.63-1.67,1.52-1.65c0.86,0.02,1.46,0.67,1.47,1.64c0.01,2.65,0,5.3-0.02,7.95c-0.01,0.97-0.63,1.62-1.48,1.62 c-0.89,0-1.48-0.66-1.49-1.68C25.38,32.81,25.39,31.48,25.4,30.16C25.39,30.16,25.39,30.16,25.4,30.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173125646285177935030000009613980926526029497_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6652,
    y1: 24.0044,
    x2: 34.7747,
    y2: 4.1473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173125646285177935030000009613980926526029497_)"
    },
    d: "M38.91,8.83 c-0.05,0.26-0.11,0.52-0.16,0.78c-0.38,1.82-0.76,3.65-1.14,5.48c-0.11,0.53-0.8,0.8-1.53,0.67c-0.72-0.13-1.23-0.73-1.13-1.23 c0.05-0.26,0.11-0.52,0.16-0.77c0.04-0.18,0.07-0.36,0.11-0.54c-2.59,2.59-5.18,5.17-7.77,7.75c-0.76,0.75-1.66,1.15-2.73,1.14 c-0.96,0-1.77-0.37-2.51-0.97c-2.14-1.76-4.3-3.5-6.43-5.28c-0.53-0.45-0.96-0.48-1.54-0.08c-1.11,0.8-2.27,1.54-3.42,2.3 c-0.86,0.57-1.73,0.46-2.23-0.27c-0.53-0.75-0.3-1.62,0.58-2.22c1.2-0.81,2.4-1.62,3.61-2.41c1.61-1.05,3.26-0.96,4.75,0.25 c2.15,1.75,4.29,3.51,6.44,5.27c0.71,0.59,0.94,0.58,1.59-0.07c2.62-2.61,5.25-5.23,7.87-7.84l-2.01,0.24 c-0.54,0.07-1.02-0.5-1.13-1.23c-0.11-0.72,0.3-1.4,0.8-1.46c0.27-0.03,0.53-0.06,0.79-0.1c1.7-0.2,3.39-0.4,5.1-0.61 c0.15-0.01,0.31-0.03,0.46-0.05c0.02,0,0.05-0.01,0.07-0.01c0.07,0.01,0.14,0.01,0.21,0.02c0.02,0,0.04,0.01,0.06,0.01 C38.5,7.73,39.02,8.33,38.91,8.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128450587818238381490000012023962382905198731_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.2017,
    y1: 7.5195,
    x2: 37.2802,
    y2: 7.6801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128450587818238381490000012023962382905198731_)"
    },
    d: "M37.51,7.57c-0.02,0-0.05,0.01-0.07,0.01 c-0.15,0.02-0.31,0.04-0.46,0.05c0.01,0,0.03-0.01,0.04-0.01c0.01-0.01,0.03-0.01,0.05-0.01c0.08-0.02,0.15-0.03,0.23-0.03 C37.37,7.58,37.44,7.57,37.51,7.57z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThongKeChung);
export default __webpack_public_path__ + "static/media/icon_thong_ke_chung.5d4b50eeaaa3134325bcd26e598ce263.svg";
export { ForwardRef as ReactComponent };